export const CONFIG = {
  FORMSPREE_URL: "https://formspree.io/f/xgodporz",
  CONTACT_EMAIL: "contact@dilinh.com",
  MC_URL: "https://dilinh.us3.list-manage.com/subscribe/post-json?u=de86d1108bc7bed33f96ea9c7&id=7e782a91f1&f_id=00f1c1e5f0",
};
